const points = [
  {
    icon: '🗓️',
    title: 'Your calendar becomes your meeting list',
    description:
      'Pre-meeting skills run on a schedule against your own calendar — through an MCP server you connect — and pull the day’s meetings into the app before any of them start. Nothing to add by hand.',
  },
  {
    icon: '📋',
    title: 'An agenda, drafted for each one',
    description:
      'For every upcoming meeting, Claude drafts an agenda from the invite and recent context. Tweak it in a click — and it rides straight into the live workspace and the summary later.',
  },
  {
    icon: '🎯',
    title: 'Nothing sneaks up on you',
    description:
      'Upcoming, missed, and past sit in one list. When it’s time, start straight from the upcoming meeting — the prep is already there, and the recording links itself to the right stub.',
  },
];

const BeforeMeeting = () => {
  return (
    <section className="meetings" id="before">
      <div className="section-container">
        <p className="overline overline--center">BEFORE THE MEETING</p>
        <h2 className="section-title">You walk in already briefed</h2>
        <p className="section-subtitle">
          The work starts before the call does. Pre-meeting skills watch your calendar on a cadence,
          line up the day’s meetings, and hand each one an agenda — so you open the call with the
          prep already done.
        </p>

        <div className="meetings-grid">
          {points.map((p, i) => (
            <div key={i} className="feature-card">
              <div className="feature-icon" aria-hidden="true">
                {p.icon}
              </div>
              <h3>{p.title}</h3>
              <p>{p.description}</p>
            </div>
          ))}
        </div>

        <div className="meetings-note mono">
          Pre-meeting sync is opt-in and runs on your own calendar MCP — the app only sees what you
          connect.
        </div>
      </div>
    </section>
  );
};

export default BeforeMeeting;
